module.exports = __webpack_public_path__ + "static/media/181CV109.fbaa8d8d.jpg";